import React from 'react';
import { styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import { MobileProductCard } from '../ProductCard/MobileProductCard.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileProductGrid = ({
  products,
  productsPerRow = 5,
  regionName,
  contactLink,
  type = "grid",
  hideCtaButton
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, null, products.map((item, index) => /* @__PURE__ */ React.createElement(Grid, {
    key: index,
    productsPerRow,
    type
  }, /* @__PURE__ */ React.createElement(MobileProductCard, __spreadProps(__spreadValues({}, item), {
    tracking: regionName ? getTrackingData({
      isTrackContent: true,
      regionName,
      contentName: item.sku,
      target: "productDetail"
    }) : {},
    ctaTracking: regionName && contactLink ? getTrackingData({
      isTrackContent: true,
      regionName,
      contentName: "contactSale",
      target: contactLink,
      payload: JSON.stringify({ sku: item.sku })
    }) : {},
    type,
    addToCart: hideCtaButton ? null : item.addToCart
  })))));
};
const Wrapper = styled.div(({ theme }) => `
display: flex;
flex-wrap: wrap;
column-gap: 2px;
place-content: flex-start space-between;
background: ${theme.colors.background};
padding: 2px 0;
&::after{
  content: "";
  flex: auto;
}
padding: 5px;
`);
const Grid = styled.div(({ productsPerRow, type }) => `
  background: white;
  margin-bottom: 2px;
  ${type === "grid" ? `width: calc(${100 / productsPerRow}% - 2px);` : "width: 100%;"}
  border-radius: 8px;
  }`);

export { MobileProductGrid };
